const AdminPages = [
  { name: 'Dashboard', link: '/superadmin/dashboard' },
  { name: 'Manage Tenants', link: '/superadmin/managetenant' },
];

export default AdminPages;
